module.exports = {
  NODE_ENV: 'production',
  api_url: 'https://test-api.apps.rog-gaming.net',
  saml_url: 'https://test-saml.rog-gaming.net/saml/login?idp=https://asusfs.asus.com/adfs/services/trust',
  port: 80
}
